import React, { Component } from 'react'
import './RegistrationPage.css'
import RegistrationForm from '../../components/RegistrationForm/RegistrationForm'

export default class RegistrationPage extends Component{
    render(){
        return(
            <div>
                <RegistrationForm />
            </div>
        )
    }
}